import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5cee960e&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cee960e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cee960e')) {
      api.createRecord('5cee960e', component.options)
    } else {
      api.reload('5cee960e', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=5cee960e&scoped=true", function () {
      api.rerender('5cee960e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/cost/components/details.vue"
export default component.exports